/*
 * ******************************************************************
 * Copyright (c) 2021-2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

export class APP_ROUTES_UTIL {
    public static readonly BASE_PATH = "/";
    public static readonly SLASH: string = "/";
    public static readonly COLON: string = ":";
    public static readonly UPPER_LEVEL: string = "../";
    public static readonly PARAM: string = APP_ROUTES_UTIL.SLASH + APP_ROUTES_UTIL.COLON;
    public static readonly RELATIVE: string = "./";

    public static appendParams(route: string, params: string[]): string {
        return [route].concat(params).join(APP_ROUTES_UTIL.PARAM);
    }

    public static toUpperLevel(route?: string): string {
        return APP_ROUTES_UTIL.UPPER_LEVEL + route;
    }

    public static absolutePath(route: string, console?: string): string {
        if (!console) {
            return APP_ROUTES_UTIL.SLASH + route;
        }
        return APP_ROUTES_UTIL.BASE_PATH + console + APP_ROUTES_UTIL.SLASH + route;
    }
}
